module.exports = __webpack_public_path__ + "static/media/20170806_08day_0283AT.c3473012.jpg";